import "./OralAppliances.module.css";
import Header from "@/reusable_sections/Header";
import OurClinicalVision from "./sections/OurClinicalVision";
import BenefitsOverview from "./sections/BenefitsOverview";
import ExpertConsultation from "./sections/ExpertConsultation";
import Footer from "@/reusable_sections/Footer";
export default function OralAppliancesPage() {
  return <div>
      <Header />
      <OurClinicalVision />
      <BenefitsOverview />
      <ExpertConsultation />
      <Footer />
    </div>;
}